import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    <a href="#" className="link footer__link">
      <div>
        Made with <span style={{ color: "red" }}>❤</span> by Aun Mohammad,
        Portfolio template
      </div>
      <br />
    </a>
    <div className="footer__link">© Cheng Chien Huang</div>
  </footer>
);

export default Footer;
